import { useMemo } from 'react';
import { useSearchParams } from 'react-router';

const useSelectedPropulsions = (): string[] => {
  const [searchParameters] = useSearchParams();
  return useMemo(
    () => searchParameters.getAll('propulsion').filter((value) => value === 'BEV' || value === 'PHEV'),
    [searchParameters],
  );
};

export default useSelectedPropulsions;
